export interface PageSeoInterface {
	key: string,
	value: string
}

export class PageSeoClass implements PageSeoInterface {
	key = '';
	value = '';
}
